import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
import { articles } from '../data/articles';
import { ArticleCard } from '../components/ArticleCard';
import { Newsletter } from '../components/Newsletter';
const allCategories = ['Alle', ...Array.from(new Set(articles.map(a => a.category)))];
export function ArticlesPage() {
  const [activeCategory, setActiveCategory] = useState('Alle');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const filtered = activeCategory === 'Alle' ? articles : articles.filter(a => a.category === activeCategory);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <>
      <section className="pt-12 pb-20 bg-vita-cream" data-id="element-310">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
          {/* Page Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-312">
            <div className="inline-block w-12 h-1 bg-vita-orange rounded-full mb-4" data-id="element-313"></div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-vita-green-deep mb-4" data-id="element-314">
              Alle Artikel
            </h1>
            <p className="text-lg text-vita-text-muted max-w-2xl mx-auto" data-id="element-315">
              Entdecke unsere neuesten Beiträge zu Gesundheit und Wohlbefinden
            </p>
          </motion.div>

          {/* Category Filter */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center gap-3 mb-14" data-id="element-316">
            {allCategories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${activeCategory === cat ? 'bg-vita-green-deep text-white shadow-vita' : 'bg-white text-vita-text-muted border border-vita-border hover:border-vita-green-sage hover:text-vita-green-deep'}`} data-id="element-317">
                {cat}
              </button>)}
          </motion.div>

          {/* Articles Grid */}
          <motion.div key={activeCategory} variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-318">
            {filtered.map((article, index) => <motion.div key={article.slug} variants={cardVariants} data-id="element-319">
                <ArticleCard article={article} index={index} className="h-full" data-id="element-320" />
              </motion.div>)}
          </motion.div>

          {filtered.length === 0 && <div className="text-center py-16 text-vita-text-muted" data-id="element-321">
              <p className="text-lg" data-id="element-322">
                Keine Artikel in dieser Kategorie gefunden.
              </p>
            </div>}
        </div>
      </section>

      <Newsletter data-id="element-323" />
    </>;
}